export default __webpack_public_path__ + "static/ab-two-phones-mobile-a83103111c6258a89570991d038b309f.jpg";